module.exports = __webpack_public_path__ + "static/steelcup-b03c48ee23f1ca9d5789d0e3c92da36c.mp3";